export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4709.8f8febe7.jpg";